import { NodeEnv } from '@dvb/common';
import { routeTree } from '@milestone-portal/routeTree.gen';
import { QueryClient } from '@tanstack/react-query';
import { createBrowserHistory, createRouter } from '@tanstack/react-router';

import { NotFoundError } from './routes/-components/error/NotFoundError';

export const history = createBrowserHistory();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      gcTime: Infinity, // Disable garbage collection
      staleTime:
        import.meta.env.NODE_ENV === NodeEnv.PRODUCTION ? 1000 * 60 : 0, // 1 min (within the time will not fetch data)
    },
  },
});

export const router = createRouter({
  context: { queryClient },
  defaultNotFoundComponent: NotFoundError,
  defaultPendingMs: 100,
  defaultPreload: 'intent',
  /**
   * Since we're using React Query, we don't want loader calls to ever be stale.
   * This will ensure that the loader is always called when the route is preloaded or visited
   */
  defaultPreloadStaleTime: 0,
  history,
  routeTree,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
